import { Pipe, PipeTransform } from '@angular/core';
import { MatOption } from '@angular/material/core';

@Pipe({
  name: 'selectedItemLabel',
})
export class SelectedItemLabelPipe implements PipeTransform {
  transform(options: MatOption | MatOption[]): string {
    if (!options) {
      return '';
    }

    const array: MatOption[] = Array.isArray(options) ? options : [options];
    if (!array.length) {
      return '';
    }

    return array.map((item: MatOption) => item.getLabel()).reduce((prev: string, curr: string) => `${prev}, ${curr}`);
  }
}
